export default "__VITE_ASSET__CSEWlfEp__"